// extracted by mini-css-extract-plugin
module.exports = {"element":"ClassOverview_element_29NCO","body":"ClassOverview_body_26W-G","menuItem":"ClassOverview_menuItem_1ZZPk","category":"ClassOverview_category_24Z4A"};